import type { HttpClient } from '@/utils/HttpClient';

export type ApiGatewayBody = {
  query: any;
  variables?: any;
  operationName?: string;
};

export type ApiGateway = {
  post: <T>(endpoint: string, body: ApiGatewayBody) => Promise<T>;
};

export const ApiGatewayService = (httpClient: HttpClient): ApiGateway => ({
  post(endpoint, body) {
    return httpClient({ endpoint, method: 'POST', body });
  },
});
